module.exports = __webpack_public_path__ + "static/media/jesus.889cdb50.jpg";